import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { TextLink } from '@companion-professional/components';
import { getOSName, isMobile } from '../../lib/ua';

// MobileCameraHelpLink is a component that provides a link to the help page for mobile camera issues.  The link is
// generated based on the user's OS (currently only iOS and Android are supported).  Returns null if the user is not
// on a mobile device.
export const MobileCameraHelpLink: FunctionComponent = () => {
  if (!isMobile()) {
    return null;
  }

  let linkUrl = '';
  switch (getOSName()) {
    case 'iOS':
      linkUrl = `../ios-help`;
      break;
    case 'Android':
      linkUrl = `../android-help`;
      break;
    default:
      // This is an OS that we don't have specific help for.
      return null;
  }

  return (
    <div className="mt-4">
      <TextLink asChild className="text-sm sm:text-md">
        <Link to={linkUrl}>Need help with your mobile camera?</Link>
      </TextLink>
    </div>
  );
};
